// ApiHeader.jsx

import React from 'react';

// Context
import { useBase } from 'context/BaseContext';
import { useTheme } from 'context/ThemeContext';

// CSS
import './ApiHeader.css';

// Components
import ApiDownloadActions from './ApiDownloadActions';

/**
 * ApiHeader
 *
 * Title row for the standalone Base API page.
 *
 * @param {boolean} [hideIdentity=false] - Hide title (e.g. when shown in GlobalToolbar).
 * @param {boolean} [hideActions=false] - Hide download actions (e.g. when moved below content).
 * @param {boolean} canDownloadOpenApi
 * @param {function} onDownloadOpenApi
 * @param {boolean} canDownloadSchema
 * @param {function} onDownloadSchema
 * @returns {ReactNode}
 */
const ApiHeader = ({
  hideIdentity = false,
  hideActions = false,
  canDownloadOpenApi,
  onDownloadOpenApi,
  canDownloadSchema,
  onDownloadSchema,
}) => {
  const { theme } = useTheme();
  const { activeBase } = useBase();

  const resolvedTitle = String(
    activeBase?.title || 'Space',
  ).trim();
  const headerTitle = resolvedTitle ? `${resolvedTitle} - API` : 'Base API';

  const showIdentity = !hideIdentity;
  const showActions = !hideActions;

  if (!showIdentity && !showActions) {
    return null;
  }

  return (
    <div className="api-header-container">
      {showIdentity ? (
        <div className="api-header-details">
          <div
            className="api-header-title"
            style={{
              color: theme?.foreground,
            }}
          >
            {headerTitle}
          </div>
        </div>
      ) : null}

      {showActions ? (
        <div className="api-header-actions">
          <ApiDownloadActions
            canDownloadOpenApi={canDownloadOpenApi}
            canDownloadSchema={canDownloadSchema}
            onDownloadOpenApi={onDownloadOpenApi}
            onDownloadSchema={onDownloadSchema}
          />
        </div>
      ) : null}
    </div>
  );
};

ApiHeader.displayName = 'ApiHeader';

export default ApiHeader;
